import { useQuery } from "react-query";
import { getOfficesForSecurity } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useOfficesForSecurity = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetOfficesForSecurity",
    getOfficesForSecurity,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
